module.exports = __webpack_public_path__ + "img/20220624173030.f01c198c.png";